import * as React from 'react';

interface IIcon {
  name: string;
}

export const Icon = (props: IIcon) => <i className={`icon-${props.name}`} />;
